import React from 'react';
import {Badge, Button} from 'reactstrap';
import classNames from 'classnames';
import CrontabEditor from './CrontabEditor';

class SchedulerRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleEnable = this.handleEnable.bind(this);
        this.handleDisable = this.handleDisable.bind(this);
        this.handleCrontab = this.handleCrontab.bind(this);
    }

    handleEnable() {
        this.onUpdate({enabled: true});
    }

    handleDisable() {
        this.onUpdate({enabled: false});
    }

    handleCrontab(crontab) {
        this.onUpdate({crontab});
    }

    onUpdate(newValues) {
        this.props.onUpdate(this.props.node, this.props.property, Object.assign(this.props.data, newValues));
    }

    render() {
        const {data, property} = this.props;
        if (!data) {
            return null;
        }
        const {crontab, enabled, nextInvocation} = data;
        return (
            <tr className={classNames({'table-info': enabled})}>
                <td scope="row">{property.id}</td>
                <td>
                    <div>
                        <CrontabEditor crontab={crontab} onSubmit={this.handleCrontab} />
                    </div>
                    {nextInvocation && <time dateTime={nextInvocation}>{new Date(nextInvocation).toLocaleString()}</time>}
                </td>
                <td>
                    {enabled && <Badge pill color="info">enabled</Badge> || <Badge pill>disabled</Badge>}
                </td>
                <td>
                    {enabled &&
                        <Button color="danger" size="sm" onClick={this.handleDisable}>Disable</Button> ||
                        <Button color="success" size="sm" onClick={this.handleEnable}>Enable</Button>}
                </td>
            </tr>
        );
    }
}

export default SchedulerRow;
